const state = {
  freeFlight: {
    success: true,
    data: {
      flightInlandItemSearchList: []
    }
  }, //自由组合数据
  rxjsMsg: {},
  // flightList: { success: null },  //渲染使用的
  tabName: '', //TAB切换,当前的TAB页面
  filter: [], //筛选项
  currentIndex: 1, //当前第几程
  choseTickets: [], // 选中的机票
  flightAllPriceInfo: {
    data: {
      data: {
        inlandDetailInfos: []
      }
    }
  }, //查询舱位价格信息（全部价格）
  sort: {
    type: "default",
    sort: "default"
  }, //排序规则
  loading: true,
  errormsg: false,
  parameter3: {}, //3.0查询参数  循环使用
  listNum: 0, //3.0查询返回的列表条数 
  showProgress: false, // 是否显示进度条 
  progressSuccess: false,
  dialogVisible: false, //对话框
  directionId: '',
  ticketIndex: -1, //当前选择的团队票 索引,
  priceDetailInfo: [], //选中的机票详细信息，成人价和儿童价

  // reloadProgress: true,  //是否重新加载进度条 1.新打开情况下 2.下一程
  currentRuleInfo: [],
  showRuleInfoLoading: false,
  ruleInfoCache: [],// 缓存当前展开仓位已请求过的退改签信息
}
export default state